export default __webpack_public_path__ + "static/media/chevron-right.59591d6a.svg";